module.exports = "https://coursera_assets.s3.amazonaws.com/images/3f78765a7884dbd4213d20fb985130c7.png";